import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { getSlugByLang, getLangBySlug } from "../common/Helper";
import { languageOptions } from "../common/Config";

const LanguageURLSyncRedirect = () => {
  const userLang = useSelector(state => state.user.language); // e.g., "French"
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentLangSlug = getLangBySlug(location.pathname.split("/")[1]); // e.g., "French"
    const correctLangSlug = getSlugByLang(userLang); // e.g., "fr"

    if (!correctLangSlug) return;

    // If route already has a valid lang but different — update
    if (currentLangSlug && currentLangSlug !== userLang) {
      const parts = location.pathname.split("/");
      parts[1] = correctLangSlug;
      const newPath = parts.join("/") + location.search + location.hash;
      navigate(newPath, { replace: true });
    }

    // If no lang in path — insert it
    if (!currentLangSlug) {
      const parts = location.pathname.split("/");
      parts.splice(1, 0, correctLangSlug);
      const newPath = parts.join("/") + location.search + location.hash;
      navigate(newPath, { replace: true });
    }
  }, [userLang, location.pathname]);

  return null;
};

export default LanguageURLSyncRedirect;
